import React from 'react';
import { MinimumBuyBanner } from './MinimumBuyBanner';
import { useScrollDetection } from './hooks/useScrollDetection';
import { useCart } from "@ecommerce/store";
import { useCategories } from './hooks/useCategories';
import { SCROLL_THRESHOLD, NAVBAR_HEIGHT, TOP_BANNER_HEIGHT } from './Navbar/NavbarConstants';
import ShoppingCartDrawer from '../ShoppingCart/ShoppingCartDrawer';
import { Navbar } from './Navbar/Navbar';
import { useCategoriesNavigation } from './hooks/useNavigation';
import { useNavbarCategoriesDrawer } from './hooks/useNavbarCategoriesDrawer';
import CategoryFilterBar from "../../pages/category/CategoryFilterBar";
import { Box } from "@mui/material";
import { CategoriesDrawer } from './Navbar/CategoriesMenu/CategoriesDrawer';
import {useLocation, useParams} from "react-router-dom";
import { ProductCategoryFilter } from "../../types/Category";
import { useProductCategoryContext } from "../../contexts/ProductCategoryContext";



const Header: React.FC = () => {
    const isScrolled = useScrollDetection(SCROLL_THRESHOLD);
    const { cartCount, cartItems, isCartOpen, toggleCart, closeCart } = useCart();
    const { rootCategories, loading, error, getSubcategories } = useCategories();
    const location = useLocation();
    const params = useParams();
    const shouldShowFilter =
        location.pathname === '/productos' ||
        (location.pathname.startsWith('/categoria/') && params.sku);
    const { breadcrumbs, loadCategoryData, loadAllProductsData, filter } = useProductCategoryContext();

    const {
        drawerOpen,
        productosOpen,
        expandedCategories,
        toggleDrawer,
        toggleProductos,
        toggleCategory,
        closeDrawer,
    } = useNavbarCategoriesDrawer();

    const {
        handleNavigation,
        handleCategoryClick,
        handleViewAllInCategory
    } = useCategoriesNavigation(closeDrawer);

    const navbarHeight = isScrolled ? NAVBAR_HEIGHT.scrolled : NAVBAR_HEIGHT.normal;
    const totalHeaderHeight = TOP_BANNER_HEIGHT + navbarHeight;

    return (
        <>
            <MinimumBuyBanner />

            <Navbar
                isScrolled={isScrolled}
                cartCount={cartCount}
                onMenuClick={toggleDrawer}
                onCartClick={toggleCart}
            />

            {shouldShowFilter && (
                <Box
                    sx={{
                        position: 'sticky',
                        top: totalHeaderHeight,
                        zIndex: 1200,
                        backgroundColor: 'white',
                        borderBottom: '1px solid #e0e0e0'
                    }}
                >
                    <CategoryFilterBar
                        onApplyFilter={(sku?: string, fil?: ProductCategoryFilter) => {
                            if (location.pathname === '/productos') loadAllProductsData(fil)
                            else loadCategoryData(sku, fil);
                        }}
                        currentFilter={filter}
                    />
                </Box>
            )}



            <CategoriesDrawer
                isOpen={drawerOpen}
                loading={loading}
                error={error}
                rootCategories={rootCategories}
                productosOpen={productosOpen}
                expandedCategories={expandedCategories}
                onClose={closeDrawer}
                onNavigate={handleNavigation}
                onToggleProductos={toggleProductos}
                onToggleCategory={toggleCategory}
                onCategoryClick={handleCategoryClick}
                onViewAllClick={handleViewAllInCategory}
                getSubcategories={getSubcategories}
            />

            <ShoppingCartDrawer
                cartItems={cartItems}
                isOpen={isCartOpen}
                onClose={closeCart}
                cartCount={cartCount}
            />
        </>
    );
};

export default Header;














